import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import { Link } from "react-router-dom";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function BasicCard() {
  const handleRedirect = () => {
    window.location.href = "/auth/login";
  };

  return (
    <div className="container mx-auto px-4 h-full">
      <div className="flex content-center items-center justify-center">
        <Card sx={{ minWidth: 200 }}>
          <CardContent>
            <Typography
              sx={{ fontSize: 14, textAlign: "center" }}
              color="text.secondary"
              gutterBottom
            >
              Welcome
            </Typography>
            <div className="text-center mb-3">
              <img
                style={{
                  width: "50%",
                  height: "50%",
                  class: "center",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
                alt="..."
                src={require("../../assets/img/AutomateCIS_logo.svg").default}
              />
            </div>
            <Drawer />
            <p style={{ lineHeight: "4.7", textAlign: "center" }}>
              Your Mail is Verified Successfully,
            </p>
            <p style={{ textAlign: "center" }}>
              Please Login with e-mail and Password to Dashboard.
            </p>
            <div className="col text-right" style={{ textAlignLast: "center" }}>
              <Button
                className="text-blueGray-200"
                variant="contained"
                onClick={handleRedirect}
              >
                Log in
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}